import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApplicationPackage} from '../../../enums/application-package.enum';
import {Service} from '../../../enums/service.enum';
import {Observable} from 'rxjs';
import {PageOfReportRequest} from 'src/app/model/cms-vod-core/dealing-models/page-of-report-request.model';
import {environment} from 'src/environments/environment';
import {CustomHttpUrlEncodingCodec} from '../../../main/encoder';

@Injectable({
  providedIn: 'root',
})
export class ReportRequestService {

  readonly reportRequestApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.REPORT_REQUEST;

  constructor(private http: HttpClient) {}

  getAllReportRequests(page?: number, type?: string[]): Observable<PageOfReportRequest> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (page != undefined) {
      queryParams = queryParams.set('page', <any>page);
    }
    if (type) {
      queryParams = queryParams.set('type', <any>type);
      queryParams = queryParams.set('itemCount', <any>5);
    }

    return this.http.get<PageOfReportRequest>(this.reportRequestApi, {params: queryParams});
  }
}
